<template>
  <div class="label__link mod--chat w-inline-block LKIconChat">
    <LKIconCount
      v-if="count"
      :count="count"
      class="LKIconChat__count"
    />

    <img
      src="/images/i-chat.svg"
      loading="lazy"
      alt=""
      class="label__link-img"
    >
  </div>
</template>

<script>
import LKIconCount from './LKIconCount.vue'


export default {
  name: 'LKIconChat',
  components: {
    LKIconCount,
  },
  props: {
    count: Number,
  },
}
</script>

<style lang="scss">
.LKIconChat {
  &__count {
    position: absolute;
    right: -10px;
    bottom: auto;
    left: auto;
  }
}
</style>
